import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SearchModel } from '../models/search';
import { Observable } from 'rxjs';
import { VehicleBidModel } from '../models/vehiclebids';
import { MultiBidsModel } from '../models/multibids';
import { ProductModel } from '../models/product';
import { environment } from 'src/environments/environment.local';

@Injectable({ providedIn: 'root' })
export class VehicleListService {
    constructor(private http: HttpClient) { }

    getVehicleListByAuctionDate(pageNum: number, pageSize: number, auctionDateId: number, plate: string, vin: string, make: number, model: number, state: number, color: number, year: number, emptybidsonly: boolean,vinReviewStatusId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/GetVehicleListByAuctionDate?pageNum=${pageNum}&pageSize=${pageSize}&auctionDateId=${auctionDateId}&plate=${plate}&vin=${vin}&make=${make}&model=${model}&state=${state}&color=${color}&year=${year}&emptybidsonly=${emptybidsonly}&vinReviewStatusId=${vinReviewStatusId}`);
    }

    searchAuctionVehicle(model: SearchModel, bidderId, pageNum, pageSize): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetLatestVehicles?pageNum=${pageNum}&pageSize=${pageSize}&enterpriseId=${model.enterprise}&bidderId=${bidderId}&makeId=${model.make}&modelId=${model.model}&styleId=${model.style}&fromYear=${model.yearFrom}&toYear=${model.yearTo}&auctionDateId=${model.auctionDateId}&storageLotId=${model.storageLotId}&colorId=${model.color}&iscurrentAuction=${model.iscurrentAuction}`);
    }
    
    getLatestVehiclesForSeller(model: SearchModel, bidderId, pageNum, pageSize): Observable<any> {
        return this.http.post(`${environment.BASE_API_URL}vehicle/GetLatestVehiclesForSeller`, {
            pageNum,
            pageSize,
            enterpriseId: model.enterprise,
            bidderId,
            makeId: model.make,
            modelId: model.model,
            styleId: model.style,
            fromYear: model.yearFrom,
            toYear: model.yearTo,
            auctionDateId: model.auctionDateId,
            storageLotId: model.storageLotId,
            colorId: model.color,
            iscurrentAuction: model.iscurrentAuction
        });
    }

    getVehicleDetails(pId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetVehicleDetails?productId=${pId}`);
    }
    getVehicleDetailsByProductId(pId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetVehicleDetailsByProductId?productId=${pId}`);
    }
    saveMinMaxBidAmount(vehiclebids: VehicleBidModel[]) {
        return this.http.post(`${environment.BASE_API_URL}enterprise/SaveMinMaxBidAmount`, vehiclebids);
    }

    getAllImageByTowingId(towingID: string, enterpriseId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetAllImagesByTowingId?towingID=${towingID}&enterpriseId=${enterpriseId}`);
    }

    getDefaultImageByTowingId(towingID: string, enterpriseId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetDefaultImagesByTowingId?towingID=${towingID}&enterpriseId=${enterpriseId}`);
    }

    getImagesByImageId(imageId, enterpriseId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetImagesByImageId?imageId=${imageId}&enterpriseId=${enterpriseId}`);
    }

    getCurrentBid(productId, bidderId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetCurrentBid?productId=${productId}&bidderId=${bidderId}`);
    }

    placeBid(productId, bidderId, bidAmount) {
        return this.http.get(`${environment.BASE_API_URL}vehicle/PlaceBid?productId=${productId}&bidderId=${bidderId}&bidAmount=${bidAmount}`);
    }

    PlaceMultiBids(multiBids: MultiBidsModel[]) {
        return this.http.post(`${environment.BASE_API_URL}vehicle/PlaceMultiBids`, multiBids);
    }

    vinCheck(vin): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/VinCheck?VIN_Num=${vin}`);
    }

    SaveProduct(product) {
        return this.http.post(`${environment.BASE_API_URL}vehicle/SaveProduct`, product);
    }

    uploadProductImage(productImage) {
        return this.http.post(`${environment.BASE_API_URL}vehicle/ProductImageUpload`, productImage);
    }

    getProductImagesByProductId(productId, fromPage): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetProductImagesByProductId?productId=${productId}&fromPage=${fromPage}&deviceType=W`);
    }

    deleteProductImage(imageId) {
        return this.http.get(`${environment.BASE_API_URL}vehicle/DeleteProductImage?imageId=${imageId}`);
    }

    getProductVideosByProductId(productId, fromPage): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetProductVideoByProductId?productId=${productId}&fromPage=${fromPage}&deviceType=W`);
    }

    GetProductMedia(productId: number, fromPage: string, fileType: string = 'both'): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetProductMedia?productId=${productId}&fromPage=${fromPage}&fileType=${fileType}`);
    }
    
    getExcelInputDataIds(vehicleType, make, model, color, style, state, userId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetExcelInputDataIds?vehicleType=${vehicleType}&make=${make}&model=${model}&color=${color}&style=${style}&state=${state}&userId=${userId}`);
    }

    SaveImageSetting(ImageSettings) {
        return this.http.post(`${environment.BASE_API_URL}enterprise/SaveImageSetting`, ImageSettings);
    }

    getImageSetting(productId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}enterprise/GetImageSetting?productId=${productId}`);
    }
    
    getLatestVehiclesByEnterprise(model: SearchModel, bidderId, pageNum, pageSize): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}vehicle/GetLatestVehiclesForEnterprise?pageNum=${pageNum}&pageSize=${pageSize}&enterpriseId=${model.enterprise}&bidderId=${bidderId}&makeId=${model.make}&modelId=${model.model}&styleId=${model.style}&fromYear=${model.yearFrom}&toYear=${model.yearTo}&auctionDateId=${model.auctionDateId}&colorId=${model.color}&iscurrentAuction=${model.iscurrentAuction}&storageLotId=${model.storageLotId}`);
    }

    ProductImageUploadSharedFolder(productImage) {
        return this.http.post(`${environment.BASE_API_URL}vehicle/ProductImageUploadSharedFolder`, productImage);
    }

    ProductImageVideoUploadMultipart(formData: FormData) {
        return this.http.post(`${environment.BASE_API_URL}vehicle/ProductImageVideoUploadMultipart`, formData);
    }

    DownloadExternalFile(ImageUrl): Observable<any> {
        return this.http.post(`${environment.BASE_API_URL}files/DownloadExternalFile`, ImageUrl);
    }

    fetchFileAsBlob(productId: number, fileId: number, fromPage: string): Observable<Blob> {
        const url = `${environment.BASE_API_URL}vehicle/GetProductMediaByMediaId/${productId}/${fileId}/${fromPage}`;
        return this.http.get<Blob>(url, { responseType: 'blob' as 'json' });
    }

}